import React from 'react'

interface Props {
  active: boolean
  icon: JSX.Element
  title: string
  subtitle: string
  onClick: () => void
}

const HomeScreenTile = ({ active, icon, title, subtitle, onClick }: Props) => {
  return (
    <div
      onClick={onClick}
      className={`flex-1  rounded-md flex flex-col justify-center items-center cursor-pointer min-w-[200px] border-2 ${
        active ? 'border-[#22C55E] bg-[#DBEAFE]' : 'border-white bg-grayBackground'
      }`}>
      <div className="h-4" />
      <div className={`w-8 h-8 ${active ? 'text-[#22C55E]' : 'text-black'}`}>{icon}</div>
      <div className="h-2" />
      <div className={`text-18 font-sans ${active ? 'text-[#22C55E]' : 'text-black'} font-semibold`}>{title}</div>
      <div className="h-2" />
      <div className={`text-14 font-sans ${active ? 'text-[#22C55E]' : 'text-black'}`}>{subtitle}</div>
      <div className="h-4" />
    </div>
  )
}

export default HomeScreenTile
